module.exports = __webpack_public_path__ + "img/ommax-voices-16.1d22acda.jpg";